import React, { useState } from "react";
import RequestService from "../../services/request.service";

import { toast } from 'react-toastify'

import {Button, Modal, Form, Table } from 'react-bootstrap';

import Pagination from "../../services/Pagination";


import moment from 'moment'
import 'moment/locale/es'


import ModalDetalleRefaccionamiento from './ModalDetalleRefaccionamiento'

import ModalBoutiqueNuevoRefaccionamiento from './ModalBoutiqueNuevoRefaccionamiento'

// import ModalTecnicoNuevoPresupuesto from './ModalTecnicoNuevoPresupuesto'
// import ModalDetallePresupuesto from './ModalDetallePresupuesto'

// import ModalEditarPresupuesto from './ModalEditarPresupuesto'


import { tipoPresupuesto, calcularTiempoTranscurrido } from '../../services/funcionesPublicas'


import Dialog from '../../services/Dialogs'



import './colores_presupuestos.scss'

const Refaccionamiento = () => {

  const dialog = new Dialog()

  const [ envio_server, setSeEnvio ] = useState<boolean>(false)


  // const [ show_ModalTecnicoNuevoPresupuesto, setModalTecnicoNuevoPresupuesto ] = useState<boolean>(false)
  // const handleShow_ModalTecnicoNuevoPresupuesto = () => {
  //   setModalTecnicoNuevoPresupuesto(true)
  // }
  // const handleClose_ModalTecnicoNuevoPresupuesto = () => {
  //   setModalTecnicoNuevoPresupuesto(false)
  // }



  const [allSessionsCount,setCounter] = useState(0);
  const sessionsPerPage = 50
  const [currentPage, setCurrentPage] = useState(1);

  const [ text_busqueda, setTextoBusqueda ] = useState('')

  const [ cargando_, setCargando ] = useState( false )

  const skull = { results: [] }

  const [ resultados, setResultados ] = useState<any>({...skull})

  const cargarMiReporte = async(page:number)=>{
    try{
      setCargando(true)
      let skip = 0
      if(page===0) skip = 0; else skip = (page*10);
      let response : any = await RequestService.getEndPoint(`presupuestos/refaccionamiento/${arreglo_estatus}/busqueda?where=${text_busqueda}&skip=${skip}&limit=${sessionsPerPage}`)
      setCounter(response.data.totalCount)
      setResultados(response.data.resultados)
      setCargando(false)
    }
    catch(e){
      setCargando(false)
      toast.error('Problemas al intentar cargar tus resultados')
    }
  }


  const busqueda = async () =>{
    cargarMiReporte(0)
    setCurrentPage(1)
  }

  const [ arreglo_estatus, setEstatus ] = useState<any>([true,true,true,true,true,true])


  const todos = () =>{
    setEstatus([true,true,true,true,true,true])
  }
  const ninguno = () =>{
    setEstatus([false,false,false,false,false,false])
  }


  const [ presupuesto_seleccionado, setPresupuesto ] = useState<any>({})





  const [ show_ModalDetalleRefaccionamiento, setModalDetalleRefaccionamiento ] = useState<boolean>(false)
  const handleShow_ModalDetalleRefaccionamiento = (presupuesto:any) => {
    setPresupuesto(presupuesto)
    setModalDetalleRefaccionamiento(true)
  }
  const handleClose_ModalDetalleRefaccionamiento = () => {
    setModalDetalleRefaccionamiento(false)
  }



  const [ show_ModalBoutiqueNuevoRefaccionamiento, setModalBoutiqueNuevoRefaccionamiento ] = useState<boolean>(false)
  const handleShow_ModalBoutiqueNuevoRefaccionamiento = () => {
    setModalBoutiqueNuevoRefaccionamiento(true)
  }
  const handleClose_ModalBoutiqueNuevoRefaccionamiento = () => {
    setModalBoutiqueNuevoRefaccionamiento(false)
  }




  React.useEffect(() => {
    cargarMiReporte(0)
  }, []);

      return (
          <>
            <div className="container-fluid">

              <div className="row justify-content-center">
                <div className="col-10 col-sm-11">

                    <h4>Insumos Materiales</h4>
                    <hr/>

                    <ul className="list-inline">
                    </ul>
                    


                    <div className="row">
                    
                        <div className="mb-2">
                            <label className="form-label">Búsqueda</label>
                            <div className="hstack gap-3">
                              <input className="form-control me-auto" type="text"  onKeyDown={(e)=>{if(e.keyCode === 13){ busqueda() }}} value={text_busqueda} onChange={event => setTextoBusqueda(event.target.value)} />
                              <button type="button" onClick={busqueda}  className="btn btn-secondary"><i className="fa fa-search" /></button>
                              <div className="vr"></div>
                              <button type="button" onClick={(e:any)=>{setTextoBusqueda('')}} className="btn btn-outline-danger"><i className="fa fa-trash"/></button>
                            </div>
                        </div>
                        
{                        
                        //<div>
                        //   <Form.Check inline name="group1" type="checkbox" label="NUEVO" checked={arreglo_estatus[0]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[0] = e.target.checked;  setEstatus(ne);}} id={`opciones_1`} />
                        //   <Form.Check inline name="group1" type="checkbox" label="APROBANDO" checked={arreglo_estatus[0]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[0] = e.target.checked;  setEstatus(ne);}} id={`opciones_1`} />
                        //   <Form.Check inline name="group1" type="checkbox" label="EN APROBACIÓN CORPORATIVO" checked={arreglo_estatus[1]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[1] = e.target.checked;  setEstatus(ne);}} id={`opciones_2`} />
                        //   <Form.Check inline name="group1" type="checkbox" label="APROBACIÓN CLIENTE" checked={arreglo_estatus[2]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[2] = e.target.checked;  setEstatus(ne);}} id={`opciones_3`} />
                        //   <Form.Check inline name="group1" type="checkbox" label="ACEPTADA" checked={arreglo_estatus[3]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[3] = e.target.checked;  setEstatus(ne);}} id={`opciones_4`} />
                        //   <Form.Check inline name="group1" type="checkbox" label="CANCELADA" checked={arreglo_estatus[4]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[4] = e.target.checked;  setEstatus(ne);}} id={`opciones_5`} />
                        // </div>
}
                        
                      <ul className="list-inline">
                        <li className="list-inline-item"><small className="pointer" onClick={()=>{handleShow_ModalBoutiqueNuevoRefaccionamiento()}}>Nueva Solicitud</small></li>
                        {
                          // <li className="list-inline-item"><small className="pointer" onClick={()=>{todos()}}>Todos</small> / <small className="pointer" onClick={()=>{ninguno()}}>Ninguno</small></li>
                        }
                      </ul>

                    </div>







                          {  (!cargando_) && (

                              <>

                                   {
                                     resultados.length > 0 && (

                                       <>


                                       <h5>Resultados</h5>


                                        <Table responsive="lg">
                                          <thead>
                                            <tr>
                                              <th scope="col">Folio</th>
                                              <th scope="col">Estatus</th>
                                              <th scope="col">Tipo</th>
                                              <th scope="col">Boutique</th>
                                              <th scope="col">Creación</th>
                                              <th scope="col"></th>
                                              <th scope="col"></th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {


                                              resultados.map( (presupuesto:any,indice:number) =>
                                                  <tr key={ Math.random().toString(36).substr(2, 9) } style={{fontSize:12, background : (["ROLE_BOUTIQUE"].indexOf(presupuesto.idusuario.rol) > -1 ? '#e8e8e8' : '') }} >
                                                    <td className={`v text-left _estatus_${presupuesto.idestatus_presupuesto.id}`} style={{"width":"160px"}}>
                                                        <p className="nm"><b>{presupuesto.folio}</b></p>                                                            
                                                    </td>
                                                    <td className={`v text-center estatus_presupuesto_${presupuesto.idestatus_presupuesto.id}`} style={{"width":"150px"}} >
                                                      <b>{presupuesto.idestatus_presupuesto.estatus}</b> {' '}
                                                       
                                                    </td>
                                                    <td className={`v text-center ${presupuesto.tipo_presupuesto}`} style={{"width":"150px"}} >
                                                      <p className="nm">{tipoPresupuesto(presupuesto.tipo_presupuesto)}</p>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"400px"}} >
                                                      {presupuesto.idboutique&&(<p className="nm">{presupuesto.idboutique.nombre_boutique}</p>)}
                                                    </td>
                                                    <td className="v text-left" style={{"width":"100px"}}>
                                                        <p className="nm"><b>{moment(presupuesto.fecha_creacion).format('YYYY-MM-DD')}</b></p>
                                                        <p className="nm"><small>{calcularTiempoTranscurrido(presupuesto.fecha_creacion)}</small></p>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"50px"}}>
                                                        <Button onClick={(e:any)=>{handleShow_ModalDetalleRefaccionamiento(presupuesto)}} size="sm" variant="primary"><i className="fa fa-address-book-o"/></Button>
                                                    </td>

                                                    <td className="v text-left" style={{"width":"50px"}}>
                                                    
                                                        {
                                                          // [1].indexOf(presupuesto.idestatus_presupuesto.id) > -1 && (
                                                          //       <Button onClick={(e:any)=>{console.log(presupuesto)}} size="sm" variant="warning"><i className="fa fa-edit"/></Button>
                                                          //   )
                                                        }
                                                    </td>
                                                  </tr>
                                               )
                                            }

                                          </tbody>
                                        </Table>


                                          <Pagination
                                            itemsCount={allSessionsCount}
                                            itemsPerPage={sessionsPerPage}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            cambiarPaginaEvento={cargarMiReporte}
                                            alwaysShown={false}
                                          />


                                        </>



                                       )
                                     
                                   }


                              </>

                           )}

                          {  cargando_ && (

                              <>
                                <div className="loader">
                                  <div className="loaderBar"></div>
                                </div>
                              </>


                           )}




                </div>
              </div>

            </div>






  {
    show_ModalDetalleRefaccionamiento && (
      <ModalDetalleRefaccionamiento show={show_ModalDetalleRefaccionamiento} handleClose={handleClose_ModalDetalleRefaccionamiento} presupuesto={presupuesto_seleccionado} />
      )

  }




  {
    show_ModalBoutiqueNuevoRefaccionamiento && (
      <ModalBoutiqueNuevoRefaccionamiento show={show_ModalBoutiqueNuevoRefaccionamiento} handleClose={handleClose_ModalBoutiqueNuevoRefaccionamiento}  />
      )

  }



          </>

      );
  

}

export default Refaccionamiento
